export default __webpack_public_path__ + "static/media/bg.5b6954b3.mp4";